import { concurUnlinkSuccess } from 'lib/common/messages';
import addMessage from 'action-creators/messaging/add-message';

const unlinkConcurSuccess = () => addMessage(concurUnlinkSuccess);
export default unlinkConcurSuccess;
